import React, { Component } from "react";

import { NavLink } from "react-router-dom";

import {
  Header,
  HeaderContent,
  HeaderToggler,
  Collapse,
  Nav,
  NavItem,
  Icon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  LinkList,
} from "design-react-kit";

import { ROUTES } from "../../const";

export class NHEditor extends Component {
  state = {
    collapsed: true,
  };

  manageEvtByLink = (link) => {
    this.setState({ collapsed: true });
  };

  //--- ---

  render() {
    const isOpen = !this.state.collapsed;

    return (
      <>
        <Header small theme="" type="navbar">
          <HeaderContent expand="lg" megamenu>
            <HeaderToggler
              aria-controls="nav1"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => this.setState({ collapsed: isOpen })}
            >
              <Icon icon="it-burger" />
            </HeaderToggler>
            <Collapse
              isOpen={isOpen}
              navbar
              header
              onOverlayClick={() => this.setState({ collapsed: true })}
            >
              <div className="menu-wrapper mnemo-dark">
                <Nav navbar tag="ul" vertical={false}>
                  <NavItem
                    key={`menu-item-close`}
                    tag="li"
                    onClick={() => this.setState({ collapsed: isOpen })}
                  >
                    <div className="mnemo-close-li">
                      CHIUDI <Icon icon="it-close-circle" padding={false} />
                    </div>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          aria-haspopup
                          caret
                          color="secondary"
                          nav
                        >
                          Gestione Utenti
                        </DropdownToggle>
                        <DropdownMenu
                          flip
                          ag="div"
                          className="dropdown-menu-show-fix mnemo-dark"
                        >
                          <LinkList tag="div">
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={`${ROUTES.USER_LIST}/student`}
                                tag="a"
                              >
                                Studenti
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          aria-haspopup
                          caret
                          color="secondary"
                          nav
                        >
                          Corsi
                        </DropdownToggle>
                        <DropdownMenu
                          flip
                          ag="div"
                          className="dropdown-menu-show-fix mnemo-dark"
                        >
                          <LinkList tag="div">
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.COURSE_MANAGER}
                                ag="a"
                              >
                                Elenco Corsi
                              </NavLink>
                            </NavItem>

                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.COURSE_TYPE_MANAGER}
                                ag="a"
                              >
                                Tipo Corsi
                              </NavLink>
                            </NavItem>

                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.COURSE_REPOQUIZ_MANAGER}
                                ag="a"
                              >
                                Deposito delle Domande
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          aria-haspopup
                          caret
                          color="secondary"
                          nav
                        >
                          Lezioni Sincrone
                        </DropdownToggle>
                        <DropdownMenu
                          flip
                          ag="div"
                          className="dropdown-menu-show-fix mnemo-dark"
                        >
                          <LinkList tag="div">
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                to={ROUTES.LESSON_LIVE_CLASS}
                                className="list-item"
                              >
                                Gestione Aule
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                to={ROUTES.LESSON_ONSITE_CLASS_BADGE}
                                className="list-item"
                              >
                                Badge Accesso Aula
                              </NavLink>
                            </NavItem>

                            <hr />

                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.LESSON_LIVE_SCHEDULE}
                                ag="a"
                              >
                                Lezioni Online
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.LESSON_ONSITE_SCHEDULE}
                                ag="a"
                              >
                                Lezioni in Presenza
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.TRAINING_SCHEDULE}
                                ag="a"
                              >
                                Tirocinio indiretto
                              </NavLink>
                            </NavItem>

                            <hr />

                            <NavItem>
                              <NavLink
                                to={ROUTES.LESSON_LIVE_PROCESS_ANALYTICS}
                                className="list-item"
                              >
                                Analisi frequenza exArt. 13
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to={ROUTES.LESSON_PROCESS_ANALYTICS_TFA_INDIRE}
                                className="list-item"
                              >
                                Analisi frequenza TFA INDIRE
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to={ROUTES.LESSON_PROCESS_ANALYTICS_TFA_CLASSICO}
                                className="list-item"
                              >
                                Analisi frequenza TFA CLASSICO
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                to={ROUTES.LESSON_LIVE_PROCESS_ANALYTICS_VC}
                                className="list-item"
                              >
                                Analisi frequenza 30/60 e VC [Unicamillus e Reggio]
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                to={
                                  ROUTES.LESSON_LIVE_PROCESS_ANALYTICS_VC_SECIONTGROUP
                                }
                                className="list-item"
                              >
                                Analisi frequenza 30/60 e VC [Unitelma]
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li">
                    <UncontrolledDropdown nav tag="div">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          aria-haspopup
                          caret
                          color="secondary"
                          nav
                        >
                          CMS
                        </DropdownToggle>
                        <DropdownMenu
                          flip
                          ag="div"
                          className="dropdown-menu-show-fix mnemo-dark"
                        >
                          <LinkList tag="div">
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.BLOG_CATEGORY_MANAGER}
                                ag="a"
                              >
                                Articoli
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.PAGE_MANAGER}
                                ag="a"
                              >
                                Pagine
                              </NavLink>
                            </NavItem>
                            <NavItem
                              tag="li"
                              onClick={() => this.manageEvtByLink()}
                            >
                              <NavLink
                                className="list-item"
                                to={ROUTES.LIBRARY_CATEGORY_MANAGER}
                                ag="a"
                              >
                                Biblioteca
                              </NavLink>
                            </NavItem>
                          </LinkList>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </UncontrolledDropdown>
                  </NavItem>

                  <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
                    <NavLink
                      className="nav-link"
                      to={ROUTES.PROMOTIONAL_MANAGER}
                      ag="a"
                    >
                      Promozioni
                    </NavLink>
                  </NavItem>

                  <NavItem tag="li" onClick={this.props.logout}>
                    <NavLink className="nav-link" to="/" ag="a">
                      Esci
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Collapse>
          </HeaderContent>
        </Header>
      </>
    );
  }
}
